// extracted by mini-css-extract-plugin
export default {"buttonWithLoader":"invalidTokenForm-module__buttonWithLoader__9QJ7y","content":"invalidTokenForm-module__content__XRYf2"};